<template>
    <div v-loading="loading" :style="{height: this.data.length === 0 && this.prob.length === 0 ? '100vh' : 'auto'}">
        <Nav :isDark.sync="this.isDark" @darkmode="isDark = $event"></Nav>
        <div class="container" style="height: calc(100% - 100px);">
            <h4 class="my-3">{{ this.team }}</h4>
            <p>让分：<el-input v-model="handicapNum" type="number" @change="showRes"></el-input></p>
            <p>胜：{{ parseFloat(this.win*100).toFixed(2) }}%，{{ 1/this.win }}</p>
            <p>负：{{ parseFloat(this.lose*100).toFixed(2) }}%，{{ 1/this.lose }}</p>
            <p>总分：{{ stayTwo(this.totalScore) }}</p>
            <p>让分胜：{{ parseFloat(this.handicapWin*100).toFixed(2) }}%，{{ 1/this.handicapWin }}</p>
            <p>让分负： {{ parseFloat(this.handicapLose*100).toFixed(2) }}%，{{ 1/this.handicapLose }}</p>
        </div>
        <Footer></Footer>
    </div>
</template>
<script>
import * as echarts from 'echarts';
import Nav from './nav.vue';
import Footer from './footer.vue';
import {kailiUrl, kailiCrawlerUrl} from '../../constants/http.config';
import { poissonDist,calculateScores, checkDevice } from '../../utils/utils'
export default {
    components: { Nav,Footer },
    data() {
        return {
            team: '',
            isDark: false,
            loading: false,
            data: [],
            id: '',
            league: '',
            date: '',
            isMobile: false,
            handicapNum: 0,
            homeXg: 0,
            awayXg: 0,
            win: 0,
            draw: 0,
            lose: 0,
            totalScore: 0,
            handicapWin: 0,
            handicapLose: 0,
            prob: [],
            winProb: [],
            drawProb: [],
            loseProb: []
        }
    },
    mounted() {
        this.id = this.$route.params.id;
        this.team = this.$route.query.teams;
        document.title = this.team + ' - 蒙特卡洛模拟';
        // console.log(this.$route.query.hxg,this.$route.query.axg);
        this.isMobile = checkDevice();
        
    },
    methods: {
        ///判断设备
        checkDevice,
        ///抓取数据
        fetchChartData(){
            this.loading = true
            // const apiUrl = 'https://api.qsda.net/api/crawler/kaili/' + this.id;
            // console.log(apiUrl);
            fetch(kailiCrawlerUrl + this.id, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
            })
            .then(response => response.json())
            .then(data => {
                console.log(data);
                if (data.code == 200) {
                    this.loading = false;
                    // this.$notify({
                    //     title: '抓取成功',
                    //     message: data.data,
                    //     type: 'success',    
                    //     // duration: 0
                    // });
                    this.$alert('更新数据成功！', '', {
                        confirmButtonText: '确定',
                        callback: () => {
                            location.reload();
                        }
                    });
                } else {
                    this.$notify.error({
                        title: '抓取失败',
                        message: '未知错误，请重试'
                    });
                }
            });
        },
        //转换百分数
        toPercentage(decimal) {
            let percentage = decimal * 100;
            return percentage.toFixed(2) + "%";
        },
        stayTwo(num){
            return Number(parseFloat(num).toFixed(2));
        },
        generateNormalRandom(mean, stdev) {
            // 生成 0 到 1 之间的随机数，类似 RAND()
            const u1 = Math.random();
            const u2 = Math.random();
            // console.log(u1,u2);
            
            // Box-Muller 变换生成标准正态分布随机数（均值 0，标准差 1）
            const z = Math.sqrt(-2.0 * Math.log(u1)) * Math.cos(2.0 * Math.PI * u2);
            // console.log(z);
            
            // 转换为指定均值和标准差的正态分布
            const normalValue = mean + stdev * z;
            // console.log(normalValue);
            
            // 取与 0 的最大值，类似 Excel 的 MAX
            return this.stayTwo(Math.max(normalValue, 0));
        },
        showRes(){
            const hxg = Number(this.$route.query.hxg);
        const axg = Number(this.$route.query.axg);
        // const handicap = 1.5;
        let winCount = 0;  //胜次数
        let loseCount = 0; //负次数
        let drawCount = 0 //平次数
        let handicapWinCount = 0;
        let handicapLoseLoseCount = 0;
        let totalPoin = [];// 存储 主队得分 + 客队得分 的数组
        const iterations = 20000;
        for (let index = 0; index < iterations; index++) {
            const homeP = this.generateNormalRandom(hxg,10);
            const awayP = this.generateNormalRandom(axg,10);
            const pointDifferential = homeP - awayP;
            if (homeP > awayP) {
                winCount++;
            }
            if (homeP < awayP) {
                loseCount++;
            }
            if (homeP === awayP){
                drawCount++;
            }
            if (homeP - this.handicapNum > awayP ){
                handicapWinCount++;
            }
            // console.log(homeP-10>awayP);
            totalPoin.push(this.stayTwo(homeP+awayP));
        }
        console.log(handicapWinCount);
        
        const drawProb = drawCount / iterations;
        const winProb = winCount / iterations + drawProb/2;
        const loseProb = loseCount /iterations + drawProb/2;
        this.win = winProb;
        this.lose = loseProb
        // 计算 res1 + res2 的中位数
        totalPoin.sort((a, b) => a - b); // 从小到大排序
        let median;
        const length = totalPoin.length;
        if (length % 2 === 0) {
            // 偶数长度，取中间两个数的平均值，与 Excel MEDIAN 一致
            const midIndex = length / 2;
            median = (totalPoin[midIndex - 1] + totalPoin[midIndex]) / 2;
        } else {
            // 奇数长度，取中间的数，与 Excel MEDIAN 一致
            const midIndex = Math.floor(length / 2);
            median = totalPoin[midIndex];
        }
        this.totalScore = median;
        this.handicapWin = handicapWinCount/iterations;
        this.handicapLose = 1 - this.handicapWin;
        console.log(median, winProb, loseProb, handicapWinCount);
        }
    }
}
</script>
<style lang="scss" scoped>
    @import '../../assets/sass/global.scss';
    .container{padding-top: 60px;}
</style>